import { Control, FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { z } from "zod";

const zodNumber = z.union([
  z
    .number({
      invalid_type_error: "Must be a valid number",
    })
    .min(0),
  z.nan(),
]);
export const schema = z.object({
  additionalRunTime: zodNumber.optional(),
  additionalRunTimeFee: zodNumber.optional(),
  additionalWaitingTime: zodNumber.optional(),
  additionalWaitingTimeFee: zodNumber.optional(),
  additionalUnscheduledStops: zodNumber.optional(),
  additionalUnscheduledStopsFee: zodNumber.optional(),
  airportParkingCharges: zodNumber.optional(),
  airportParkingChargesType: z.string().default(""),
  tollCharges: zodNumber.optional(),
  tollChargesType: z.string().default(""),
  otherCharges: z.array(
    z.object({
      description: z.string().min(1, { message: "Description must be at least 1 character long" }),
      amount: zodNumber,
      type: z.string(),
    })
  ),
  providerNotes: z.string().optional(),
  clientNotes: z.string().optional(),
});
export type FormData = z.infer<typeof schema>;

// Create utility type for extracting subset types
export type PickFormData<K extends keyof FormData> = Pick<FormData, K>;
export type WaitTimeFormData = PickFormData<"additionalWaitingTime" | "additionalRunTime">;

export type AirportParkingFormData = PickFormData<"airportParkingCharges" | "airportParkingChargesType">;

export type AdditionalStopsFormData = PickFormData<"additionalUnscheduledStops">;

export type TollChargesFormData = PickFormData<"tollCharges" | "tollChargesType">;

export type OtherChargesFormData = PickFormData<"otherCharges">;
export type FormRegister<T extends FieldValues> = UseFormRegister<T>;
export type FormErrors<T extends FieldValues> = FieldErrors<T>;
export type FormControl<T extends FieldValues> = Control<T>;
